import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Eye, Radio, Network, Search, Zap, FlaskConical, ArrowRight } from 'lucide-react';
export function EngineSection() {
  const process = [{
    name: 'Reality',
    icon: <Eye size={20} data-id="element-49" />
  }, {
    name: 'Signals',
    icon: <Radio size={20} data-id="element-50" />
  }, {
    name: 'Clusters',
    icon: <Network size={20} data-id="element-51" />
  }, {
    name: 'Opportunities',
    icon: <Search size={20} data-id="element-52" />
  }, {
    name: 'Ideas',
    icon: <Zap size={20} data-id="element-53" />
  }, {
    name: 'Experiments',
    icon: <FlaskConical size={20} data-id="element-54" />
  }];
  const transformations = ['Conversations become signals', 'Signals become opportunities', 'Opportunities become experiments', 'Experiments become impact'];
  return <section className="py-24 bg-white" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-57">
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-58">
            Credibility & Method
          </h2>
          <h3 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-59">
            The Latteware Engine
          </h3>
          <p className="text-xl text-gray-600" data-id="element-60">
            Our methodology transforms raw experience into innovation. This
            engine powers everything we build.
          </p>
        </div>

        {/* SparkBridge Process Pipeline */}
        <div className="mb-20" data-id="element-61">
          <h4 className="text-center font-bold text-gray-900 mb-8 text-lg" data-id="element-62">
            The SparkBridge Process
          </h4>
          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4" data-id="element-63">
            {process.map((step, idx) => <Fragment key={idx} data-id="element-64">
                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.1
            }} className="flex flex-col items-center gap-2" data-id="element-65">
                  <div className="w-16 h-16 rounded-full bg-gray-50 border-2 border-gray-200 flex items-center justify-center text-teal-600 shadow-sm" data-id="element-66">
                    {step.icon}
                  </div>
                  <span className="text-sm font-semibold text-gray-700" data-id="element-67">
                    {step.name}
                  </span>
                </motion.div>
                {idx < process.length - 1 && <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.1 + 0.1
            }} className="hidden md:block text-gray-300" data-id="element-68">
                    <ArrowRight size={24} data-id="element-69" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>

        {/* Transformations */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-70">
          {transformations.map((text, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-teal-50 p-6 rounded-xl border border-teal-100 text-center" data-id="element-71">
              <p className="font-semibold text-teal-900" data-id="element-72">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}